import request from './request'

//上传音频
export function _uploadAudio(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/upload/audio',
  })
  return request(config)
}
//课程图片上传
export function _uploadImage(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/upload/image',
  })
  return request(config)
}

//媒体库图片上传    /admin/upload/material-image?course_id=1&file=****
export function _uploadMaterialImage(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/upload/material-image',
  })
  return request(config)
}

//媒体库文件上传    /admin/upload/material-file?course_id=1&file=****
export function _uploadMaterialFile(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/upload/material-file',
  })
  return request(config)
}

//媒体库视频上传    /admin/upload/material-video?course_id=1&file=****
export function _uploadMaterialVideo(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/upload/material-video',
  })
  return request(config)
}

//媒体库音频上传    /admin/upload/material-audio?course_id=1&file=****
export function _uploadMaterialAudio(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/upload/material-audio',
  })
  return request(config)
}

//上传音频文件（分块上传）
export function _getAliYunSts(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/upload/aliyun-sts',
  })
  return request(config)
}